import {
    getPageSize,
    normalizePageSize,
    savePageSize,
} from '@/utils/pageSize.mjs';

const pagination = {
    state: {
        pageSize: getPageSize(),
        changeVersion: 0,
        changeSourceId: null,
    },
    mutations: {
        SET_PAGE_SIZE(state, payload) {
            state.pageSize = normalizePageSize(payload.value);
            state.changeSourceId = payload.sourceId || null;
            state.changeVersion += 1;
        },
        SYNC_PAGE_SIZE_FROM_STORAGE(state, value) {
            state.pageSize = normalizePageSize(value);
            state.changeSourceId = null;
            state.changeVersion += 1;
        },
    },
    actions: {
        SetPageSize({ commit }, payload) {
            const value = payload && typeof payload === 'object' ? payload.value : payload;
            const sourceId = payload && typeof payload === 'object' ? payload.sourceId : null;
            const normalized = savePageSize(value);
            commit('SET_PAGE_SIZE', { value: normalized, sourceId });
            return normalized;
        },
    },
};

export default pagination;
